import { Entity } from "../helpers/Entity"

export type EmailTemplateAttributesDto = {
    templateKey: string
    subject: string
    fromName: string
    defaultFromEmail: string
    content: string
    buttonLabel: string
    accountId: string
    attachPdfByDefault: boolean
}

export type EmailTemplateDto = {
    attributes: EmailTemplateAttributesDto
    id: string
    type: string
}

export default class EmailTemplate implements Entity {
    dto: EmailTemplateDto
    constructor(dto: EmailTemplateDto) {
        this.dto = dto
    }

    isLoaded(): boolean { 
        return this.dto.id != "" && this.dto.type == "email-templates"
    }

    getId(): string { 
        return this.dto.id 
    }

    getTemplateKey(): string {
        return this.dto.attributes.templateKey
    }

    getSubject(): string {
        return this.dto.attributes.subject
    }

    getFromName(): string {
        return this.dto.attributes.fromName
    }

    getFromEmail(): string {
        return this.dto.attributes.defaultFromEmail
    }

    getContent(): string {
        return this.dto.attributes.content
    }

    getButtonLabel(): string {
        return this.dto.attributes.buttonLabel
    }

    getAccountId(): string {
        return this.dto.attributes.accountId
    }

}


// WEBPACK FOOTER //
// ./src/state/mail/EmailTemplate.ts